module.exports = __webpack_public_path__ + "static/media/soehne-web-buch.e275dcf3.woff2";